// Shared validation utilities — single source of truth for regex patterns

export const EMAIL_REGEX = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

/**
 * Validates an email address. Returns error message or null.
 */
export function validateEmail(email) {
  if (!email || !email.trim()) return "Email is required.";
  if (!EMAIL_REGEX.test(email.trim())) return "Please enter a valid email address.";
  return null;
}

/**
 * Validates a US phone number (10 digits, optional formatting).
 * Accepts: 5551234567, 555-123-4567, (555) 123-4567, +15551234567
 * Returns error message or null.
 */
export function validatePhone(phone) {
  if (!phone || !phone.trim()) return "Phone number is required.";
  const digits = phone.replace(/[\s\-().+]/g, "");
  // 10 digits, or 11 starting with 1
  if (/^\d{10}$/.test(digits)) return null;
  if (/^1\d{10}$/.test(digits)) return null;
  return "Please enter a valid phone number (e.g. 555-123-4567).";
}
